import { render, staticRenderFns } from "./PedidoDeCompraVisualizarPedidosDeCompraView.vue?vue&type=template&id=4db91a08&scoped=true"
import script from "./PedidoDeCompraVisualizarPedidosDeCompraView.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoDeCompraVisualizarPedidosDeCompraView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PedidoDeCompraVisualizarPedidosDeCompraView.vue?vue&type=style&index=0&id=4db91a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db91a08",
  null
  
)

export default component.exports